import React, { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet';
import { useParams, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import {
  Card,
  CardHeader,
  CardTitle,
  CardContent,
  CardDescription,
} from '../components/ui/card';
import { Button } from '../components/ui/button';
import { Badge } from '../components/ui/badge';


import {
  Truck,
  MapPin,
  Calendar,
  Clock,
  DollarSign,
  Package,
  AlertTriangle,
  CheckCircle,
  XCircle,
  ArrowLeft,
  Edit,
  Save,
  Upload,
  FileText,
  MessageSquare,
  Phone,
  Mail,
  Navigation,
  Route,
  Fuel,
  Car,
  Building,
  User,
  File,
  Download,
  Eye,
  Plus,
  Trash2,
  MoreHorizontal,
  ExternalLink,
  Copy,
  Share2,
  Bookmark,
  Flag,
  Star,
  Heart,
  ThumbsUp,
  ThumbsDown,
  Smile,
  Frown,
  Meh,
  Archive,
  ArchiveRestore,
  Undo,
  Redo,
  Cut,
  Paste,
  Scissors,
  Paperclip,
  Pin,
  Tag,
  Hash,
  AtSign,
  Percent,
  Infinity,
  Pi,
  Sigma,
  Omega,
  Alpha,
  Beta,
  Gamma,
  Delta,
  Epsilon,
  Zeta,
  Eta,
  Theta,
  Iota,
  Kappa,
  Lambda,
  Mu,
  Nu,
  Xi,
  Omicron,
  Rho,
  Tau,
  Upsilon,
  Phi,
  Chi,
  Psi,
} from 'lucide-react';
import Sidebar from '../components/Sidebar';
import Topbar from '../components/Topbar';
import {
  TextField,
  Box,
  Typography,
  Chip,
  Paper,
  TableContainer,
  Button as MuiButton,
  Dialog as MuiDialog,
  DialogTitle as MuiDialogTitle,
  DialogContent as MuiDialogContent,
  DialogActions,
} from '@mui/material';

const ViajeDetalle = () => {
  const { viajeId } = useParams();
  const navigate = useNavigate();
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const [activeItem, setActiveItem] = useState('Dashboard Transportista');
  const [loading, setLoading] = useState(true);
  const [viaje, setViaje] = useState(null);
  const [incidencias, setIncidencias] = useState([]);
  const [evidencias, setEvidencias] = useState([]);
  const [showIncidenciaDialog, setShowIncidenciaDialog] = useState(false);
  const [showEvidenciaDialog, setShowEvidenciaDialog] = useState(false);
  const [nuevaIncidencia, setNuevaIncidencia] = useState({
    tipo: '',
    descripcion: '',
    impacto: ''
  });
  const [selectedFile, setSelectedFile] = useState(null);

  useEffect(() => {
    // Simular carga de datos del viaje
    setLoading(true);
    setTimeout(() => {
      setViaje({
        id: viajeId,
        numeroViaje: `VIA-2024-${viajeId.padStart(3, '0')}`,
        origen: 'Monterrey, NL',
        destino: 'Guadalajara, JAL',
        fechaInicio: '2024-01-15',
        fechaFin: '2024-01-16',
        estatus: 'completado',
        distancia: '850 km',
        ganancia: '$15,000',
        cliente: 'Empresa ABC',
        tipoCarga: 'Electrónicos',
        peso: '5,000 kg',
        volumen: '120 m³',
        temperatura: '15-25°C',
        instrucciones: 'Manejar con cuidado, carga frágil',
        contactoCliente: {
          nombre: 'Juan Pérez',
          telefono: '+52 81 1234 5678',
          email: 'juan.perez@empresaabc.com'
        },
        vehiculo: {
          placa: 'ABC-123',
          tipo: 'Tractocamión',
          capacidad: '8,000 kg'
        },
        conductor: {
          nombre: 'Carlos Rodríguez',
          licencia: 'CDL-123456',
          telefono: '+52 81 9876 5432'
        },
        ruta: [
          { punto: 'Monterrey, NL', hora: '08:00', fecha: '2024-01-15', estatus: 'completado' },
          { punto: 'Saltillo, COAH', hora: '10:30', fecha: '2024-01-15', estatus: 'completado' },
          { punto: 'San Luis Potosí, SLP', hora: '14:00', fecha: '2024-01-15', estatus: 'completado' },
          { punto: 'León, GTO', hora: '17:30', fecha: '2024-01-15', estatus: 'completado' },
          { punto: 'Guadalajara, JAL', hora: '21:00', fecha: '2024-01-16', estatus: 'completado' }
        ]
      });

      setIncidencias([
        {
          id: 1,
          fecha: '2024-01-15 12:30',
          tipo: 'retraso',
          descripcion: 'Retraso por condiciones climáticas en Saltillo',
          impacto: '1 hora',
          estatus: 'resuelta',
          solucion: 'Se reanudó el viaje cuando mejoró el clima'
        }
      ]);

      setEvidencias([
        {
          id: 1,
          tipo: 'foto',
          descripcion: 'Carga en origen',
          fecha: '2024-01-15 08:00',
          archivo: 'carga_origen.jpg'
        },
        {
          id: 2,
          tipo: 'documento',
          descripcion: 'Manifiesto de carga',
          fecha: '2024-01-15 08:15',
          archivo: 'manifiesto.pdf'
        },
        {
          id: 3,
          tipo: 'foto',
          descripcion: 'Carga en destino',
          fecha: '2024-01-16 21:00',
          archivo: 'carga_destino.jpg'
        }
      ]);

      setLoading(false);
    }, 1000);
  }, [viajeId]);

  const getEstatusColor = (estatus) => {
    switch (estatus) {
      case 'completado':
        return 'bg-green-100 text-green-800';
      case 'en_progreso':
        return 'bg-blue-100 text-blue-800';
      case 'programado':
        return 'bg-yellow-100 text-yellow-800';
      case 'cancelado':
        return 'bg-red-100 text-red-800';
      default:
        return 'bg-gray-100 text-gray-800';
    }
  };

  const getEstatusText = (estatus) => {
    switch (estatus) {
      case 'completado':
        return 'Completado';
      case 'en_progreso':
        return 'En Progreso';
      case 'programado':
        return 'Programado';
      case 'cancelado':
        return 'Cancelado';
      default:
        return estatus;
    }
  };

  const handleFileUpload = (event) => {
    const file = event.target.files[0];
    setSelectedFile(file);
  };

  const handleAgregarIncidencia = () => {
    if (!nuevaIncidencia.tipo || !nuevaIncidencia.descripcion) {
      toast.error('Por favor completa todos los campos');
      return;
    }

    const incidencia = {
      id: incidencias.length + 1,
      fecha: new Date().toISOString(),
      ...nuevaIncidencia,
      estatus: 'abierta'
    };

    setIncidencias([...incidencias, incidencia]);
    setNuevaIncidencia({ tipo: '', descripcion: '', impacto: '' });
    setShowIncidenciaDialog(false);
    toast.success('Incidencia agregada exitosamente');
  };

  const handleAgregarEvidencia = () => {
    if (!selectedFile) {
      toast.error('Por favor selecciona un archivo');
      return;
    }

    const evidencia = {
      id: evidencias.length + 1,
      tipo: selectedFile.type.startsWith('image/') ? 'foto' : 'documento',
      descripcion: `Evidencia ${evidencias.length + 1}`,
      fecha: new Date().toISOString(),
      archivo: selectedFile.name
    };

    setEvidencias([...evidencias, evidencia]);
    setSelectedFile(null);
    setShowEvidenciaDialog(false);
    toast.success('Evidencia agregada exitosamente');
  };

  const handleLogout = () => {
    localStorage.clear();
    navigate('/login', { replace: true });
  };

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="text-center">
          <div className="animate-spin rounded-full h-32 w-32 border-b-2 border-blue-600 mx-auto"></div>
          <p className="mt-4 text-gray-600">Cargando detalles del viaje...</p>
        </div>
      </div>
    );
  }

  if (!viaje) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="text-center">
          <XCircle className="h-16 w-16 text-red-500 mx-auto mb-4" />
          <h2 className="text-2xl font-bold text-gray-900 mb-2">Viaje no encontrado</h2>
          <p className="text-gray-600 mb-4">El viaje que buscas no existe o no tienes permisos para verlo.</p>
          <Button onClick={() => navigate('/transportista-dashboard')}>
            <ArrowLeft className="h-4 w-4 mr-2" />
            Volver al Dashboard
          </Button>
        </div>
      </div>
    );
  }

  return (
    <div className="flex">
      <Sidebar
        isOpen={sidebarOpen}
        setSidebarOpen={setSidebarOpen}
        activeItem={activeItem}
        setActiveItem={setActiveItem}
        onLogout={handleLogout}
      />

      <div className={`transition-all duration-300 flex-1 ${sidebarOpen ? 'ml-64' : 'ml-16'} bg-gray-100 min-h-screen`}>
        <Topbar showSearch={false} />
        
        <div className="p-6">
          <Helmet>
            <title>Detalle del Viaje {viaje.numeroViaje} | OMS AMERISA</title>
          </Helmet>

          {/* Header */}
          <div className="mb-6">
            <div className="flex items-center gap-4 mb-4">
              <Button variant="outline" onClick={() => navigate('/transportista-dashboard')}>
                <ArrowLeft className="h-4 w-4 mr-2" />
                Volver
              </Button>
              <div>
                <h1 className="text-3xl font-bold text-gray-900">{viaje.numeroViaje}</h1>
                <p className="text-gray-600">Detalles completos del viaje</p>
              </div>
            </div>
            <div className="flex items-center gap-4">
              <Badge className={getEstatusColor(viaje.estatus)}>
                {getEstatusText(viaje.estatus)}
              </Badge>
              <span className="text-sm text-gray-500">
                {viaje.fechaInicio} - {viaje.fechaFin || 'En curso'}
              </span>
            </div>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
            {/* Información principal */}
            <div className="lg:col-span-2 space-y-6">
              {/* Información del viaje */}
              <Card>
                <CardHeader>
                  <CardTitle className="flex items-center gap-2">
                    <Truck className="h-5 w-5" />
                    Información del Viaje
                  </CardTitle>
                </CardHeader>
                <CardContent>
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                    <div>
                      <h3 className="font-semibold mb-3">Ruta</h3>
                      <div className="space-y-2">
                        <div className="flex items-center gap-2">
                          <MapPin className="h-4 w-4 text-green-600" />
                          <span className="text-sm"><strong>Origen:</strong> {viaje.origen}</span>
                        </div>
                        <div className="flex items-center gap-2">
                          <MapPin className="h-4 w-4 text-red-600" />
                          <span className="text-sm"><strong>Destino:</strong> {viaje.destino}</span>
                        </div>
                        <div className="flex items-center gap-2">
                          <Route className="h-4 w-4 text-blue-600" />
                          <span className="text-sm"><strong>Distancia:</strong> {viaje.distancia}</span>
                        </div>
                      </div>
                    </div>
                    <div>
                      <h3 className="font-semibold mb-3">Carga</h3>
                      <div className="space-y-2">
                        <div className="flex items-center gap-2">
                          <Package className="h-4 w-4 text-purple-600" />
                          <span className="text-sm"><strong>Tipo:</strong> {viaje.tipoCarga}</span>
                        </div>
                        <div className="flex items-center gap-2">
                          <Car className="h-4 w-4 text-orange-600" />
                          <span className="text-sm"><strong>Peso:</strong> {viaje.peso}</span>
                        </div>
                        <div className="flex items-center gap-2">
                          <Building className="h-4 w-4 text-indigo-600" />
                          <span className="text-sm"><strong>Volumen:</strong> {viaje.volumen}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                  {viaje.instrucciones && (
                    <div className="mt-4 p-3 bg-yellow-50 border border-yellow-200 rounded-lg">
                      <h4 className="font-semibold text-yellow-800 mb-1">Instrucciones Especiales</h4>
                      <p className="text-sm text-yellow-700">{viaje.instrucciones}</p>
                    </div>
                  )}
                </CardContent>
              </Card>

              {/* Ruta detallada */}
              <Card>
                <CardHeader>
                  <CardTitle className="flex items-center gap-2">
                    <Navigation className="h-5 w-5" />
                    Ruta Detallada
                  </CardTitle>
                </CardHeader>
                <CardContent>
                  <div className="space-y-3">
                    {viaje.ruta.map((punto, index) => (
                      <div key={index} className="flex items-center gap-3 p-3 border rounded-lg">
                        <div className="flex-shrink-0">
                          {punto.estatus === 'completado' ? (
                            <CheckCircle className="h-5 w-5 text-green-600" />
                          ) : (
                            <Clock className="h-5 w-5 text-yellow-600" />
                          )}
                        </div>
                        <div className="flex-1">
                          <div className="font-medium">{punto.punto}</div>
                          <div className="text-sm text-gray-500">
                            {punto.fecha} a las {punto.hora}
                          </div>
                        </div>
                        <Badge className={punto.estatus === 'completado' ? 'bg-green-100 text-green-800' : 'bg-yellow-100 text-yellow-800'}>
                          {punto.estatus === 'completado' ? 'Completado' : 'Pendiente'}
                        </Badge>
                      </div>
                    ))}
                  </div>
                </CardContent>
              </Card>

              {/* Incidencias */}
              <Card>
                <CardHeader>
                  <div className="flex items-center justify-between">
                    <CardTitle className="flex items-center gap-2">
                      <AlertTriangle className="h-5 w-5" />
                      Incidencias
                    </CardTitle>
                    <MuiDialog open={showIncidenciaDialog} onClose={() => setShowIncidenciaDialog(false)}>
                      <MuiDialogTitle>Nueva Incidencia</MuiDialogTitle>
                      <MuiDialogContent>
                        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                          Reporta una incidencia durante el viaje
                        </Typography>
                        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                          <TextField
                            label="Tipo de Incidencia"
                            value={nuevaIncidencia.tipo}
                            onChange={(e) => setNuevaIncidencia({...nuevaIncidencia, tipo: e.target.value})}
                            placeholder="Ej: Retraso, Avería, Clima"
                            fullWidth
                            variant="outlined"
                          />
                          <TextField
                            label="Descripción"
                            value={nuevaIncidencia.descripcion}
                            onChange={(e) => setNuevaIncidencia({...nuevaIncidencia, descripcion: e.target.value})}
                            placeholder="Describe la incidencia..."
                            multiline
                            rows={3}
                            fullWidth
                            variant="outlined"
                          />
                          <TextField
                            label="Impacto"
                            value={nuevaIncidencia.impacto}
                            onChange={(e) => setNuevaIncidencia({...nuevaIncidencia, impacto: e.target.value})}
                            placeholder="Ej: 2 horas de retraso"
                            fullWidth
                            variant="outlined"
                          />
                        </Box>
                      </MuiDialogContent>
                      <DialogActions>
                        <MuiButton onClick={() => setShowIncidenciaDialog(false)}>
                          Cancelar
                        </MuiButton>
                        <MuiButton onClick={handleAgregarIncidencia} variant="contained">
                          Agregar Incidencia
                        </MuiButton>
                      </DialogActions>
                    </MuiDialog>
                    <Button size="sm" onClick={() => setShowIncidenciaDialog(true)}>
                      <Plus className="h-4 w-4 mr-2" />
                      Agregar Incidencia
                    </Button>
                  </div>
                </CardHeader>
                <CardContent>
                  {incidencias.length === 0 ? (
                    <p className="text-gray-500 text-center py-4">No hay incidencias reportadas</p>
                  ) : (
                    <div className="space-y-3">
                      {incidencias.map((incidencia) => (
                        <div key={incidencia.id} className="p-3 border rounded-lg">
                          <div className="flex items-center justify-between mb-2">
                            <div className="flex items-center gap-2">
                              <Badge variant="outline">{incidencia.tipo}</Badge>
                              <span className="text-sm text-gray-500">{incidencia.fecha}</span>
                            </div>
                            <Badge className={incidencia.estatus === 'resuelta' ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800'}>
                              {incidencia.estatus === 'resuelta' ? 'Resuelta' : 'Abierta'}
                            </Badge>
                          </div>
                          <p className="text-sm mb-2">{incidencia.descripcion}</p>
                          <div className="text-xs text-gray-500">
                            <strong>Impacto:</strong> {incidencia.impacto}
                            {incidencia.solucion && (
                              <>
                                <br />
                                <strong>Solución:</strong> {incidencia.solucion}
                              </>
                            )}
                          </div>
                        </div>
                      ))}
                    </div>
                  )}
                </CardContent>
              </Card>

              {/* Evidencias */}
              <Card>
                <CardHeader>
                  <div className="flex items-center justify-between">
                    <CardTitle className="flex items-center gap-2">
                      <FileText className="h-5 w-5" />
                      Evidencias
                    </CardTitle>
                    <MuiDialog open={showEvidenciaDialog} onClose={() => setShowEvidenciaDialog(false)}>
                      <MuiDialogTitle>Nueva Evidencia</MuiDialogTitle>
                      <MuiDialogContent>
                        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                          Sube una foto o documento como evidencia
                        </Typography>
                        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                          <TextField
                            type="file"
                            accept=".pdf,.jpg,.jpeg,.png"
                            onChange={handleFileUpload}
                            fullWidth
                            variant="outlined"
                          />
                        </Box>
                      </MuiDialogContent>
                      <DialogActions>
                        <MuiButton onClick={() => setShowEvidenciaDialog(false)}>
                          Cancelar
                        </MuiButton>
                        <MuiButton onClick={handleAgregarEvidencia} variant="contained">
                          Agregar Evidencia
                        </MuiButton>
                      </DialogActions>
                    </MuiDialog>
                    <Button size="sm" onClick={() => setShowEvidenciaDialog(true)}>
                      <Upload className="h-4 w-4 mr-2" />
                      Agregar Evidencia
                    </Button>
                  </div>
                </CardHeader>
                <CardContent>
                  {evidencias.length === 0 ? (
                    <p className="text-gray-500 text-center py-4">No hay evidencias cargadas</p>
                  ) : (
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                      {evidencias.map((evidencia) => (
                        <div key={evidencia.id} className="p-3 border rounded-lg">
                          <div className="flex items-center gap-2 mb-2">
                            {evidencia.tipo === 'foto' ? (
                              <File className="h-4 w-4 text-blue-600" />
                            ) : (
                              <FileText className="h-4 w-4 text-green-600" />
                            )}
                            <span className="font-medium text-sm">{evidencia.descripcion}</span>
                          </div>
                          <p className="text-xs text-gray-500 mb-2">{evidencia.fecha}</p>
                          <div className="flex gap-2">
                            <Button variant="outline" size="sm">
                              <Eye className="h-3 w-3 mr-1" />
                              Ver
                            </Button>
                            <Button variant="outline" size="sm">
                              <Download className="h-3 w-3 mr-1" />
                              Descargar
                            </Button>
                          </div>
                        </div>
                      ))}
                    </div>
                  )}
                </CardContent>
              </Card>
            </div>

            {/* Sidebar con información adicional */}
            <div className="space-y-6">
              {/* Información financiera */}
              <Card>
                <CardHeader>
                  <CardTitle className="flex items-center gap-2">
                    <DollarSign className="h-5 w-5" />
                    Información Financiera
                  </CardTitle>
                </CardHeader>
                <CardContent>
                  <div className="space-y-3">
                    <div className="flex justify-between">
                      <span className="text-sm">Ganancia:</span>
                      <span className="font-semibold text-green-600">{viaje.ganancia}</span>
                    </div>
                    <div className="flex justify-between">
                      <span className="text-sm">Distancia:</span>
                      <span className="text-sm">{viaje.distancia}</span>
                    </div>
                    <div className="flex justify-between">
                      <span className="text-sm">Combustible estimado:</span>
                      <span className="text-sm">~$3,500</span>
                    </div>
                    <div className="flex justify-between">
                      <span className="text-sm">Gastos adicionales:</span>
                      <span className="text-sm">$500</span>
                    </div>
                    <hr />
                    <div className="flex justify-between font-semibold">
                      <span>Ganancia neta:</span>
                      <span className="text-green-600">$11,000</span>
                    </div>
                  </div>
                </CardContent>
              </Card>

              {/* Información del cliente */}
              <Card>
                <CardHeader>
                  <CardTitle className="flex items-center gap-2">
                    <Building className="h-5 w-5" />
                    Cliente
                  </CardTitle>
                </CardHeader>
                <CardContent>
                  <div className="space-y-3">
                    <div>
                      <h4 className="font-semibold">{viaje.cliente}</h4>
                      <div className="text-sm text-gray-600 mt-2">
                        <div className="flex items-center gap-2 mb-1">
                          <User className="h-4 w-4" />
                          {viaje.contactoCliente.nombre}
                        </div>
                        <div className="flex items-center gap-2 mb-1">
                          <Phone className="h-4 w-4" />
                          {viaje.contactoCliente.telefono}
                        </div>
                        <div className="flex items-center gap-2">
                          <Mail className="h-4 w-4" />
                          {viaje.contactoCliente.email}
                        </div>
                      </div>
                    </div>
                  </div>
                </CardContent>
              </Card>

              {/* Información del vehículo */}
              <Card>
                <CardHeader>
                  <CardTitle className="flex items-center gap-2">
                    <Car className="h-5 w-5" />
                    Vehículo
                  </CardTitle>
                </CardHeader>
                <CardContent>
                  <div className="space-y-3">
                    <div>
                      <h4 className="font-semibold">{viaje.vehiculo.placa}</h4>
                      <p className="text-sm text-gray-600">{viaje.vehiculo.tipo}</p>
                      <p className="text-sm text-gray-600">Capacidad: {viaje.vehiculo.capacidad}</p>
                    </div>
                  </div>
                </CardContent>
              </Card>

              {/* Información del conductor */}
              <Card>
                <CardHeader>
                  <CardTitle className="flex items-center gap-2">
                    <User className="h-5 w-5" />
                    Conductor
                  </CardTitle>
                </CardHeader>
                <CardContent>
                  <div className="space-y-3">
                    <div>
                      <h4 className="font-semibold">{viaje.conductor.nombre}</h4>
                      <p className="text-sm text-gray-600">Licencia: {viaje.conductor.licencia}</p>
                      <div className="flex items-center gap-2 mt-2">
                        <Phone className="h-4 w-4" />
                        <span className="text-sm">{viaje.conductor.telefono}</span>
                      </div>
                    </div>
                  </div>
                </CardContent>
              </Card>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ViajeDetalle; 